import React from 'react'
import CustomHighchart from 'components/highcharts/CustomHighchart';
import CompanySearch from 'components/search/CompanySearch';

const T = {
  bg:   '#F6F5F0',
  card: '#FFFFFF',
  line: '#E5E2D8',
  ink:  '#232821',
  mut:  '#6E766C',
  acc:  '#2E9E7A',
};

const CustomTab = (props) => {
    const { tabs, activeTab, setActiveTab, seriesData, selected, setSelected, handleInputChange, isTabLoading } = props

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Header row: Title + Tabs on left, Search on right */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16 }}>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div style={{
                        fontFamily: "'Bricolage Grotesque', sans-serif",
                        fontSize: 16,
                        fontWeight: 700,
                        color: T.ink,
                    }}>
                        {tabs[activeTab].title}
                    </div>

                    <div style={{ display: 'flex', gap: 4, overflowX: 'auto', paddingBottom: 4 }}>
                        {tabs && tabs.map((tab, index) => {
                            const isActive = activeTab === index;
                            return (
                                <button
                                    key={index}
                                    onClick={() => setActiveTab(index)}
                                    style={{
                                        padding: '7px 14px',
                                        borderRadius: 999,
                                        border: `1px solid ${T.ink}`,
                                        background: isActive ? T.ink : 'transparent',
                                        color: isActive ? T.bg : T.mut,
                                        fontSize: 12.5,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        fontFamily: 'inherit',
                                        outline: 'none',
                                        transition: 'background 0.15s, color 0.15s',
                                        flexShrink: 0,
                                    }}
                                >
                                    {tab.title}
                                </button>
                            )
                        })}
                    </div>
                </div>

                {/* Company Search Component */}
                <div style={{ flex: 1, minWidth: 260, display: 'flex', justifyContent: 'flex-end' }}>
                    <CompanySearch
                        selected={selected}
                        setSelected={setSelected}
                        handleInputChange={handleInputChange}
                    />
                </div>
            </div>

            {/* Chart Area */}
            <div style={{ marginTop: 8, position: 'relative' }}>
                <CustomHighchart seriesData={seriesData} />
                {/* Subtle loading overlay — keeps chart visible, no full-card flicker */}
                {isTabLoading && (
                    <div style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 8,
                        backdropFilter: 'blur(1px)',
                        zIndex: 10,
                    }}>
                        <div style={{
                            width: 20,
                            height: 20,
                            border: `2.5px solid ${T.line}`,
                            borderTopColor: T.acc,
                            borderRadius: '50%',
                            animation: 'spin 0.7s linear infinite',
                        }} />
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CustomTab